<!--発駅 箱根フリーパス・丹沢/大山のみ表示  -->
<template>
  <div class="row">
    <!-- 発駅 -->
    <label class="name">{{ $t("common.fromStation") }}</label>

    <!-- 選んだ駅名 -->
    <div class="value">
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BFromStationSelect",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
